export const ACCESS_TOKEN_COOKIE = 'pwcc-access-token';
export const REFRESH_TOKEN_COOKIE = 'pwcc-refresh-token';
export const NONCE_COOKIE = 'pwcc-nonce';
export const FANATICS_TENANT_ID_COOKIE = 'fanatics-tenant-id';
